import React from 'react'
import {useEffect, useState} from 'react'
import {Lang} from 'yougile-lang'
import {NetworkStatusClient} from '@client/network-status-client'
import {DivWithHint} from '@components/common/hint/hint'
import {Icon} from './common/base/icon'

const useNetworkWarning = (): boolean => {
  const [warning, setWarning] = useState(() =>
    NetworkStatusClient.shouldShowNetworkWarning()
  )

  useEffect(() => {
    const id = setInterval(() => {
      const warning = NetworkStatusClient.shouldShowNetworkWarning()
      setWarning(warning)
    }, 1000)
    return () => clearInterval(id)
  }, [setWarning])

  return warning
}

interface Props {
  className?: string
}

export const NetworkWarning = ({className}: Props) => {
  const warning = useNetworkWarning()
  return warning ? (
    <DivWithHint content={Lang.msg.noConnection} className={className}>
      <Icon icon="IconCloudOff" color="error" size={16} />
    </DivWithHint>
  ) : null
}
